import Axios from "axios";
import route from "./../../Routes";
import Vue from 'vue'
// import { Info } from "luxon";
export default {
  state: {
    data: "",
    email: "",
    checkbox: "",
    textarea: "",
    selected: "",
    message: "",
    reason: "",
    users: [],
    usersCert: [],
    mode: "dev",
    dev: "https://devapi.programminghub.io",
    prod: "https://api.programminghub.io",
    loader: false,
    addQuerySel: "Monthly",
    ListData: [],
    CourseData: [],
    currentTab: "Home",
    alertCert: false,
    TotalPagesCert: null,
    pageNumber: 0, //default 0
    searchUser: "",
    searchedUserData: "",
    searchCertHere: "",
    selectCertEmail: "certificate_id",
    showButton: true,
    resetPasswordMsg: null,
    addEmail: "", //add user
    addPassword: "",
    helpDeskData: null,
    selectSale: "true",
    selectStatus: "No response",
    inputComments: "",
    inputAtendee: "",
    access: [],
    loginError: "",
    checked: [],
    checkedCategories: [],
    newAddedUser: "",
    languageList: [],
    pythonxProUserList: [],
    hackerxProUserList: [],
    offerList: []
  },
  mutations: {
    setUserData(state, data) {
      state.users = data;
    },
    setUserDataCert(state, data) {
      state.usersCert = data;
    },
    updateData(state, msg) {
      state.data = msg;
    },
    updateEmail(state, msg) {
      state.email = msg;
    },
    updateAddEmail(state, msg) {
      state.addEmail = msg;
    },
    updateAddPassword(state, msg) {
      state.addPassword = msg;
    },
    updateCheckbox(state, msg) {
      state.checkbox = msg;
    },
    updateTextarea(state, msg) {
      state.textarea = msg;
    },
    updateSelected(state, msg) {
      state.selected = msg;
    },
    updateMessage(state, msg) {
      state.message = msg;
    },
    updateReason(state, msg) {
      state.reason = msg;
    },
    setResponse(state, msg) {
      state.message = msg.message;
      state.reason = msg.Reason;
    },
    updateLoader(state, msg) {
      state.loader = msg;
    },
    updateAddQuerySel(state, msg) {
      state.addQuerySel = msg;
    },
    creatingListData(state, msg) {
      state.ListData = msg;
    },
    creatingProCourseList(state, msg) {
      state.CourseData = msg;
    },
    setMode(state, value) {
      state.mode = value && value.mode ? value.mode : value;
    },
    setTab(state, value) {
      state.currentTab = value.tab;
    },
    alertCert(state, value) {
      state.alertCert = value;
    },
    updateTotalNumberofPagesCert(state, value) {
      state.TotalPagesCert = value;
    },
    updatePageNumber(state, value) {
      state.pageNumber = value;
    },
    updateSearchUser(state, value) {
      state.searchUser = value;
    },
    setSearchedUserData(state, value) {
      state.searchedUserData = value;
    },
    updateSearchCertHere(state, value) {
      state.searchCertHere = value;
    },
    updateSelectCertEmail(state, value) {
      state.selectCertEmail = value;
    },
    updateShowButton(state, value) {
      state.showButton = value;
    },
    updateResetPassword(state, value) {
      state.resetPasswordMsg = value;
    },
    setHelpDeskData(state, value) {
      state.helpDeskData = value;
    },
    updateSelectSale(state, value) {
      state.selectSale = value;
    },
    updateSelectStatus(state, value) {
      state.selectStatus = value;
    },
    updateInputComments(state, value) {
      state.inputComments = value;
    },
    updateInputAtendee(state, value) {
      state.inputAtendee = value;
    },
    updateAccess(state, value) {
      state.access = value[0].access;
    },
    updateAccess__(state, value) {
      state.access = value;
    },
    clearAccess_(state, value) {
      state.access = value;
    },
    loginError(state, value) {
      state.loginError = value;
    },
    updateLoaderStatus(state, value) {
      state.loader = value.value;
    },
    updateCheckedCategories(state, value) {
      state.checkedCategories = value;
    },
    updateNewAddedUser(state, value) {
      state.newAddedUser = value;
    },
    setUserLanguageList(state, value) {
      state.languageList = value;
    },
    SET_PYTHONX_PRO_USER_LIST(state, value) {
      state.pythonxProUserList = value
    },
    SET_HACKERX_PRO_USER_LIST(state, value) {
      state.hackerxProUserList = value
    },
    SET_OFFER_DATA(state, data) {
      if (data && data.length) {
        state.offerList = data.map(d=>{
          if (d.center_section.points && d.center_section.points.length) {
            d.center_section.points = d.center_section.points.map(p=>{
                return {text: p}
            })
          } else {
            d.center_section.points = [{text: ""}]
          }
          return d
        })
      }
    }
  },
  getters: {
    showData: state => state,
    showMessage: state => state.message,
    showReason: state => state.reason,
    showUsers: state => state.users,
    showUsersCert: state => state.usersCert,
    showLoader: state => state.loader
  },
  actions: {
    //########### SET MODE IS BEING CALLED VIA PAGE1, PAGE 2, PAGE 3
    updateLoaderStatus({ commit }, payload) {
      commit("updateLoaderStatus", payload);
    },
    setMode({ commit, dispatch }, payload) {
      // console.log(payload, "========from set mode store=========")
      commit("setMode", payload);
      // dispatch("getUserData", payload.value);
      dispatch("getUserData", payload);
    },
    //########### CURRENT TAB IS BEING CALLED VIA MAIN PAGE i.e., APP.vue
    currentTab({ commit }, payload) {
      commit("setTab", payload);
    },
    updateAccess_({ commit }, payload) {
      commit("updateAccess__", payload.access);
    },
    clearAccess({ commit }) {
      commit("clearAccess_", []);
    },

    //========================= PAGE 1/ TabularData/ Promocode API's =========================
    // getUserData is being called every time when mode is changed to dev/prod
    async getUserData({ commit, state, dispatch }, payload) {
      // console.log(payload, 'from get user data API');
      if (state.currentTab === "proUser" || state.currentTab === "/") {
        commit("setMode", payload);
        dispatch("creatingList", payload);
        // this block is calling second page api
      }
      if (
        state.currentTab === "promocode"
        // route.history.current.fullPath === "/"
      ) {
        commit("setMode", payload);
        commit("updateLoader", true);
        if (payload && payload.mode === "Dev") {
          Axios.get(
            `${state.dev}/v2/api/payment/failureList?page=&limit=`
          ).then(response => {
            commit("setUserData", response.data);
            commit("updateLoader", false);
          });
        } else {
          Axios.get(
            `${state.prod}/v2/api/payment/failureList?page=&limit=`
          ).then(response => {
            commit("setUserData", response.data);
            commit("updateLoader", false);
          });
        }
      }
      if (state.currentTab === "certificates") {
        commit("setMode", payload);
        dispatch("getUserDataCert", payload);
      }
      if (state.currentTab === "resetPassword") {
        commit("setMode", payload);
        dispatch("searchUser_", payload);
      }
      if (state.currentTab === "helpDesk") {
        commit("setMode", payload);
        dispatch("getHelpDesk", payload);
      }
      if (state.currentTab === "promocode") {
        commit("setMode", payload);
        dispatch("creatingList", payload);
        // this block is calling second page api
      }
    },
    async addUserData({ state }, payload) {
      if (payload.mode === "Dev") {
        return await Axios.post(`${state.dev}/addFailurePayment`, {
          email: payload.email,
          type: payload.type,
          comments: payload.comments
        });
      } else {
        return await Axios.post(`${state.prod}/addFailurePayment`, {
          email: payload.email,
          type: payload.type,
          comments: payload.comments
        });
      }
    },
    async viewComments({ commit, state }, payload) {
      if (payload.mode === "Dev") {
        return await Axios.post(
          `${state.dev}/v2/api/payment/update/status`,
          payload,
          {
            _id: payload._id,
            comment: payload.comment,
            status: payload.status
          }
        );
      } else {
        return await Axios.post(
          `${state.prod}/v2/api/payment/update/status`,
          payload,
          {
            _id: payload._id,
            comment: payload.comment,
            status: payload.status
          }
        );
      }
    },
    //========================= PAGE 1/ TabularData/ Promocode API's ENDS =================

    //========================= PAGE 2/ TabularData2/Pro USers API's =========================
    async addPromoData({ state, commit }, payload) {
      commit("updateLoader", true);
      if (state.mode === "Dev") {
        let response = await Axios.post(
          `${state.dev}/v2/api/auth/addProUser`,
          payload
        );
        commit("updateLoader", false);
        return response.status;
      } else {
        const response = await Axios.post(
          `${state.prod}/v2/api/auth/addProUser`,
          payload
        );
        commit("updateLoader", false);
        return response.status;
      }
    },

    async creatingList({ commit, state }, payload) {
      commit("updateLoader", true);
      if (payload.mode === "Dev") {
        await Axios.get(
          `${state.dev}/v2/api/auth/getProUserList?page=1&limit=50`
        ).then(response => {
          if (response) {
            commit("creatingListData", response.data.data);
            commit("updateLoader", false);
          } else {
            commit("updateLoader", false);
          }
        });
      } else {
        await Axios.get(
          `${state.prod}/v2/api/auth/getProUserList?page=1&limit=50`
        ).then(prodResponse => {
          if (prodResponse) {
            commit("creatingListData", prodResponse.data.data);
            commit("updateLoader", false);
          } else {
            commit("updateLoader", false);
          }
        });
      }
    },

    async creatingCouserUserList({ commit, state }, payload) {
      commit("updateLoader", true);
      if (payload.mode === "Dev") {
        await Axios.get(
          `${state.dev}/v2/api/auth/pro/course-user?page=1&limit=50`
        ).then(response => {
          if (response) {
            commit("creatingProCourseList", response.data.data);
            console.log(response.data.data);
            commit("updateLoader", false);
          } else {
            commit("updateLoader", false);
          }
        });
      } else {
        await Axios.get(
          `${state.prod}/v2/api/auth/pro/course-user?page=1&limit=50`
        ).then(prodResponse => {
          if (prodResponse) {
            commit("creatingProCourseList", prodResponse.data.data);
            commit("updateLoader", false);
          } else {
            commit("updateLoader", false);
          }
        });
      }
    },

    async addProCouseUser({ state, commit }, payload) {
      commit("updateLoader", true);
      if (state.mode === "Dev") {
        let response = await Axios.post(
          `${state.dev}/v2/api/auth/pro/course-user`,
          payload
        );
        commit("updateLoader", false);
        return response.status;
      } else {
        const response = await Axios.post(
          `${state.prod}/v2/api/auth/pro/course-user`,
          payload
        );
        commit("updateLoader", false);
        return response.status;
      }
    },
    //========================= PAGE 2/ TabularData2/Pro USers API's ENDS =========================

    //======================= PAGE 3/ Certificates API's =========================
    async getUserDataCert({ commit, state }, payload) {
      commit("updateShowButton", true);
      if (!payload.pageNum) {
        payload.pageNum = state.pageNumber + 1;
      }
      if (
        state.currentTab === "certificates" ||
        state.currentTab === "helpDesk"
      ) {
        commit("setMode", payload);
        commit("updateLoader", true);
        commit("setUserDataCert", null);
        if (payload.mode === "Dev") {
          Axios.get(
            `${
            state.dev
            }/v1/api/userCertificate/getCertificateList?page=${state.pageNumber +
            1}&limit=100`
          ).then(response => {
            commit("setUserDataCert", response.data.data);
            commit(
              "updateTotalNumberofPagesCert",
              response.data.count[0]["count(*)"]
            );
            commit("updateLoader", false);
          });
        } else {
          commit("setMode", payload);
          commit("updateLoader", true);
          commit("setUserDataCert", null);
          Axios.get(
            `${
            state.prod
            }/v1/api/userCertificate/getCertificateList?page=${state.pageNumber +
            1}&limit=100`
          ).then(response => {
            commit("setUserDataCert", response.data.data);
            commit(
              "updateTotalNumberofPagesCert",
              response.data.count[0]["count(*)"]
            );
            commit("updateLoader", false);
          });
        }
      }
    },
    async addUser({ commit, state }, payload) {
      if (payload.mode) {
        var newUserAdded = state.addEmail;
        let res = await Axios.post(`${state.dev}/v2/api/failureuser/add/user`, {
          email: state.addEmail,
          password: state.addPassword,
          access: payload.idArray
        })
          .then(res => {
            commit("updateMessage", res.data.message);
            commit("updateNewAddedUser", newUserAdded);
            commit("updateAddEmail", null);
            commit("updateAddPassword", null);
            commit("updateCheckedCategories", []);
          })
          .catch(err => {
            commit("updateAddEmail", null);
            commit("updateAddPassword", null);
          });
      } else {
        let response = await Axios.post(
          `${state.prod}/v2/api/failureuser/add/user`,
          {
            email: state.addEmail,
            password: state.addPassword,
            access: payload.idArray
          }
        );
      }
    },
    async delUser({ commit, state }, payload) {
      commit("updateLoader", true);
      commit("updateReason", "");
      commit("updateMessage", "");
      if (payload.mode === "Dev") {
        let res = await Axios.delete(
          `${state.dev}/v2/api/auth/removeUser/${payload.email}`
        )
          .then(res => {
            let { message, reason } = res.data;
            commit("updateLoader", false);
            commit("setResponse", { message: message, Reason: reason });
          })
          .catch(err => {
            commit("updateLoader", false);
          });
      } else {
        let response = await Axios.delete(
          `${state.prod}/v2/api/auth/removeUser/${payload.email}`
        )
          .then(res => {
            let { Message, reason } = res.data;
            commit("setResponse", { message: Message, Reason: reason });
            commit("updateLoader", false);
          })
          .catch(err => {
            commit("updateLoader", false);
          });
      }
    },
    async updateDataCert({ commit, state }, payload) {
      commit("updateShowButton", true);
      if (payload.mode === "Dev") {
        return await Axios.post(
          `${state.dev}/v1/api/userCertificate/updateusercertificate`,
          {
            certificate_id: payload.certificate_id,
            name: payload.name
          }
        );
      } else {
        return await Axios.post(
          `${state.prod}/v1/api/userCertificate/updateusercertificate`,
          {
            certificate_id: payload.certificate_id,
            name: payload.name
          }
        );
      }
    },
    async searchCert_({ commit, state }, payload) {
      commit("updateLoader", true);
      commit("setUserDataCert", null);
      if (payload.mode === "Dev") {
        return await Axios.get(
          `${state.dev}/v1/api/userCertificate/search?type=${state.selectCertEmail}&keyword=${state.searchCertHere}`
        ).then(response => {
          commit("setUserDataCert", response.data.data);
          commit("updateLoader", false);
        }).catch(err => {
          commit("updateLoader", false);
          Vue.toasted.show('oops!! something went wrong, try reloading page', {
            type: 'error',
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000
          });
        })
      } else {
        return await Axios.get(
          `${state.prod}/v1/api/userCertificate/search?type=${state.selectCertEmail}&keyword=${state.searchCertHere}`
        ).then(response => {
          commit("setUserDataCert", response.data.data);
          commit("updateLoader", false);
        });
      }
    },
    async getLanguageList({ commit, state }, payload) {
      // commit("updateLoader", true);
      commit("setUserLanguageList", null);
      if (payload.mode === "Dev") {
        return await Axios.get(
          `${state.dev}/v1/api/language/language.json?client=android&version=12`
        ).then(response => {
          commit("setUserLanguageList", response.data.data);
          commit("updateLoader", false);
        });
      } else {
        return await Axios.get(
          `${state.prod}/v1/api/language/language.json?client=android&version=12`
        ).then(response => {
          commit("setUserLanguageList", response.data.data);
          commit("updateLoader", false);
        });
      }
    },
    async createNewCertificate({ commit, state }, payload) {
      commit("updateLoader", true);
      // commit("setUserLanguageList", null);
      if (payload.mode === "Dev") {
        return await Axios.post(
          `${state.dev}/v2/api/certification/createusercertificate`,
          payload
        )
          .then(response => {
            // commit("setUserLanguageList", response.data.data);
            commit("updateLoader", false);
            return response;
          })
          .catch(err => {
            commit("updateLoader", false);
            return false;
          });
      } else {
        return await Axios.post(
          `${state.prod}/v2/api/certification/createusercertificate`,
          payload
        )
          .then(response => {
            // commit("setUserLanguageList", response.data.data);
            commit("updateLoader", false);
            return response;
          })
          .catch(err => {
            commit("updateLoader", false);
            return false;
          });
      }
    },
    //========================= PAGE 3/ Certificates API's ENDS =========================

    //======================= PAGE 4/ resetpassword API's =========================
    async searchUser_({ commit, state }, payload) {
      if (state.currentTab === "resetPassword" || state.currentTab === "/") {
        commit("setMode", payload);
        commit("setSearchedUserData", null);
        commit('updateLoader', true)
        if (payload.mode === "Dev") {
          Axios.get(
            `${state.dev}/v2/api/auth/getUser?email=${state.searchUser}`
          ).then(response => {
            commit("setSearchedUserData", response.data.data);
            commit('updateLoader', false)
          });
        } else {
          // commit('updateLoader', true)
          commit("setMode", payload);
          commit("setSearchedUserData", null);
          Axios.get(
            `${state.prod}/v2/api/auth/getUser?email=${state.searchUser}`
          ).then(response => {
            commit("setSearchedUserData", response.data.data);
            commit('updateLoader', false)
          });
        }
      }
    },
    async resetPassword_({ commit, state }, payload) {
      commit("setMode", payload);
      commit("updateResetPassword", null);
      if (payload.mode === "Dev") {
        let response = await Axios.post(
          `${state.dev}/v2/api/auth/changePassword`,
          {
            email: state.searchedUserData.email_id
          }
        );
        commit("updateResetPassword", response.data.Message);
      } else {
        let response = await Axios.post(
          `${state.prod}/v2/api/auth/changePassword`,
          {
            email: state.searchedUserData.email_id
          }
        );
        commit("updateResetPassword", response.data.Message);
      }
    },
    //========================= PAGE 4/ reset Password API's ENDS =========================

    //======================= PAGE 5/ helpDesk API's =========================
    async getHelpDesk({ commit, state }, payload) {
      if (state.currentTab === "helpDesk" || state.currentTab === "/") {
        commit("setMode", payload);
        commit("setHelpDeskData", null);
        commit('updateLoader', true)
        if (payload.mode === "Dev") {
          Axios.get(`${state.dev}/v2/api/auth/get/helpList`).then(response => {
            commit("setHelpDeskData", response.data);
            commit('updateLoader', false)
          });
        } else {
          commit("setMode", payload);
          commit("setHelpDeskData", null);
          Axios.get(`${state.prod}/v2/api/auth/get/helpList`).then(response => {
            commit("setHelpDeskData", response.data);
            commit('updateLoader', false)
          });
        }
      }
    },
    async putHelpDesk({ commit, state }, payload) {
      if (payload.mode === "Dev") {
        let response = await Axios.put(
          `${state.dev}/v2/api/auth/update/helpStatus`,
          {
            _id: payload.info._id,
            Sale: state.selectSale,
            Atendee: state.inputAtendee,
            Status: state.selectStatus,
            Comments: state.inputComments
          }
        );
        if (response) {
          commit("setMode", payload);
        }
        return true;
      } else {
        let response_two = await Axios.put(
          `${state.prod}/v2/api/auth/update/helpStatus`,
          {
            _id: payload.info._id,
            Sale: state.selectSale,
            Atendee: state.inputAtendee,
            Status: state.selectStatus,
            Comments: state.inputComments
          }
        );
        if (response_two) {
          commit("setMode", payload);
        }
        return true;
      }
    },
    //========================= PAGE 5/ helpDesk API's ENDS =========================

    //======================= PAGE 6/ login API's =========================
    async login({ commit, state }, payload) {
      // console.log(state.currentTab, "currentTab")
      if (state.currentTab === "login" || state.currentTab === "/") {
        commit("setMode", payload);
        commit("updateLoader", true);
        localStorage.setItem("Mode", state.mode);
        // commit('updateAccess', null)
        if (payload.mode === "Dev") {
          Axios.post(`${state.dev}/v2/api/failureuser/user/login`, {
            email: payload.email,
            password: payload.password
          })
            .then(response => {
              if (response && response.data) {
                commit("updateAccess", response.data.data);
                localStorage.setItem(
                  "storedAccess",
                  JSON.stringify(response.data.data[0].access)
                );
                localStorage.setItem("storedData", response.data.data[0]._id);
                route.push(`${state.access[1].path}`);
              }
            })
            .catch(err => {
              commit("updateLoader", false);
              commit("loginError", "Invalid Login");
            });
        } else {
          commit("setMode", payload);
          Axios.post(`${state.prod}/v2/api/failureuser/user/login`, {
            email: payload.email,
            password: payload.password
          })
            .then(response => {
              if (response && response.data) {
                commit("updateAccess", response.data.data);
                localStorage.setItem(
                  "storedAccess",
                  JSON.stringify(response.data.data[0].access)
                );
                localStorage.setItem("storedData", response.data.data[0]._id);
                route.push(`${state.access[0].path}`);
                commit("updateLoader", false);
              }
            })
            .catch(err => {
              commit("updateLoader", false);
              commit("loginError", "Invalid Login");
            });
        }
      }
    },

    //========================= PAGE 6/ login API's ENDS =========================

    //========================= PAGE 7/ PythonX/Pro USers API's =========================
    async fetchPythonxProUserList({ commit, state }) {
      commit("updateLoader", true);
      await Axios.get(
        `https://us-central1-pythonx-2c2cc.cloudfunctions.net/payment/getProUserList`
      ).then(response => {
        if (response) {
          let { data } = response.data
          if (data && data.length) {
            data = data.map(d => {
              d.created_date = Vue.moment(d.createdDate._seconds * 1000).format('DD-MM-YYYY')
              return d
            })
          }
          commit("SET_PYTHONX_PRO_USER_LIST", data);
          commit("updateLoader", false);
        } else {
          commit("updateLoader", false);
        }
      });
    },

    async addPythonxProCourseUser({ state, commit }, payload) {
      commit("updateLoader", true);
      let response = await Axios.post(
        'https://us-central1-pythonx-2c2cc.cloudfunctions.net/payment/addProUser',
        payload
      );
      commit("updateLoader", false);
      return response.status;
    },
    //========================= PAGE 7/ TabularData2/Pro USers API's ENDS =========================

    //========================= PAGE 8/ HackerX/Pro USers API's =========================
    async fetchHackerxProUserList({ commit, state }) {
      commit("updateLoader", true);
      await Axios.get(
        `http://us-central1-projectx-rs2020.cloudfunctions.net/payment/getProUserList`
      ).then(response => {
        if (response) {
          let { data } = response.data
          if (data && data.length) {
            data = data.map(d => {
              d.created_date = Vue.moment(d.createdDate._seconds * 1000).format('DD-MM-YYYY')
              return d
            })
          }
          commit("SET_HACKERX_PRO_USER_LIST", data);
          commit("updateLoader", false);
        } else {
          commit("updateLoader", false);
        }
      });
    },

    async addHackerxProCourseUser({ state, commit }, payload) {
      commit("updateLoader", true);
      let response = await Axios.post(
        'http://us-central1-projectx-rs2020.cloudfunctions.net/payment/addProUser',
        payload
      );
      commit("updateLoader", false);
      return response.status;
    },
    //========================= PAGE 8/ TabularData2/Pro USers API's ENDS =========================

    //========================= PAGE 9/ OFFERS API's ENDS =========================
   
    async getOfferData({ state, commit }, payload) {
      const { mode } = payload
      let url = state.dev

      if (mode === 'prod') {
        url = state.prod
      } 

      commit("updateLoader", true);
      let response = await Axios.get(`${url}/v2/api/promo/dynamic-offer`);
      const { Data } = response.data
      commit("SET_OFFER_DATA", Data);
      commit("updateLoader", false);
      return response.status;
    },


    async addOffer({ state, commit }, payload) {
      const { formData, mode, edit } = payload
      let url = state.dev

      if (mode === 'prod') {
        url = state.prod
      } 

      commit("updateLoader", true);
      let response = null
      if (edit) {
        response = await Axios.put(`${url}/v2/api/promo/dynamic-offer`, formData);
      } else {
        response = await Axios.post(`${url}/v2/api/promo/dynamic-offer`, formData);
      }
      commit("updateLoader", false);
      return response.status;
    },
    //========================= PAGE 9/ OFFERS API's ENDS =========================
    resetMessages({ commit, state }) {
      commit("updateReason", "");
      commit("updateMessage", "");
    }
  }
};
